import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LagbasLogo from '../components/LagbasLogo';

// Flatbox-konfiguratorn körs som egen sub-app (/flatbox-app/, byggd av
// scripts/build-flatbox.mjs) i en iframe, så att LagbasN:s globala CSS inte
// påverkar utseendet eller utskrifterna. Samma origin – inloggningen delas.
// PDF-filnamnet sätts av utskriftskoden (print.js) på toppfönstrets titel.
const APP_URL = '/flatbox-app/index.html';

// Djuplänkar: /flatbox?offer=FB2678 öppnar offerten, /flatbox?lead=<id> skapar
// en ny offert från leadet. Parametrarna skickas vidare till iframen, som läser
// dem vid start. Sub-appen meddelar sedan aktuell offert (flatbox:url) så att
// adressfältet följer med, och ber om navigering i LagbasN (flatbox:navigate).
export default function FlatboxPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const frameRef = useRef(null);
  // Bara startadressen – iframen laddas inte om när adressfältet uppdateras.
  const [src] = useState(() => APP_URL + location.search);

  useEffect(() => {
    const onMessage = e => {
      if (e.origin !== window.location.origin || e.source !== frameRef.current?.contentWindow) return;
      const msg = e.data || {};
      if (msg.type === 'flatbox:url' && typeof msg.search === 'string') {
        if (msg.search !== window.location.search) navigate({ search: msg.search }, { replace: true });
      } else if (msg.type === 'flatbox:navigate' && typeof msg.path === 'string' && msg.path.startsWith('/')) {
        navigate(msg.path);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [navigate]);

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ bgcolor: '#1a1a1a', color: 'white', py: 1.5, px: 3,
        display: 'flex', alignItems: 'center', gap: 2 }}>
        <LagbasLogo />
        <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.2)', mx: -0.5 }} />
        <IconButton color="inherit" size="small" onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">Flatbox</Typography>
          <Typography variant="caption" sx={{ color: '#aaa' }}>
            Prismodell, offert, avtal och säljstöd
          </Typography>
        </Box>
      </Box>
      <Box component="iframe" ref={frameRef} src={src} title="Flatbox"
        sx={{ flex: 1, width: '100%', border: 0, display: 'block' }} />
    </Box>
  );
}
